import { PAYOUT_INTERVAL, PAYOUT_STATUSES } from '../../../../../../services/exports/Constants';

export default {
  headers: {
    payout_info: 'Informacje o wypłacie',
    payouts: 'Wypłaty',
  },
  form: {
    invoicing_emails: {
      label: 'Wysyłaj faktury na',
      placeholder: 'Wprowadź swój e-mail',
    },
    payout_schedule: {
      label: 'Harmonogram wypłat',
      options: {
        [PAYOUT_INTERVAL.MANUAL]: 'Wstrzymane wypłaty',
        [PAYOUT_INTERVAL.DAILY]: 'Codzienne wypłaty',
        [PAYOUT_INTERVAL.WEEKLY]: 'Tygodniowe wypłaty',
        [PAYOUT_INTERVAL.MONTHLY]: 'Miesięczne wypłaty',
      },
    },
  },
  fields: {
    id: 'ID',
    company: 'Restauracja',
    amount: 'Kwota',
    cash_amount: 'Kwota gotówkowa',
    paypal_standalone_amount: 'Kwota PayPal',
    period: 'Okres',
    paid_at: 'Zapłacono',
    provider: 'Dostawca',
    status: 'Status',
    actions: 'Akcje',
  },
  providers: {
    stripe: 'Stripe',
    adyen: 'Adyen',
    paypal: 'PayPal',
    paypal_standalone: 'PayPal',
    cash: 'Gotówka',
    system: 'System',
  },
  buttons: {
    save: 'Zapisz',
    actions: 'Akcje',
    open_report: 'Otwórz raport',
    open_tracking_url: 'Śledź wypłatę',
  },
  statuses: {
    [PAYOUT_STATUSES.created]: 'Oczekujące',
    [PAYOUT_STATUSES.processing]: 'W trakcie',
    [PAYOUT_STATUSES.paid]: 'Zapłacono',
    [PAYOUT_STATUSES.failed]: 'Nieudane',
    undefined: 'Nieznany',
    null: 'Nieznany',
  },
  toasts: {
    failed_to_load_data: 'Błąd pobierania danych',
    successfully_updated: 'Pomyślnie zaktualizowano',
  },
};
